import { Component, EventEmitter, Inject, Output } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { OfferVM } from 'src/app/models/offer.model';
import { AccountService } from 'src/app/services/account.service';
import { AlertService, MessageSeverity } from 'src/app/services/alert.service';

@Component({
  selector: 'editDialogComponent',
  templateUrl: './editDialogComponent.component.html',
})

export class EditDialogComponent {

  clientName: string = undefined;
  @Output() saveFromParent = new EventEmitter<boolean>();

  constructor(
    private accountService: AccountService,
    private alertService: AlertService,
    public dialogRef: MatDialogRef<EditDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { offer: OfferVM }
  ) { }

  onNoClick(): void {
    this.dialogRef.close();
  }

  saveCloneOffer() {
    if (this.clientName === undefined ||
        this.clientName === '') {
      this.saveFailedHelper("Client name is mandatory!");
      return;
    }

    this.data.offer.clientName = this.clientName;

    this.accountService.cloneOffer(this.data.offer).subscribe(
      role => {
        this.saveSuccessHelper(`Clone offer saved successfully!`)
        this.saveFromParent.emit(true);
        this.dialogRef.close();
      },
      error => this.saveFailedHelper(error));
  }

  private saveSuccessHelper(mesaj?: string) {
    this.alertService.stopLoadingMessage();
    this.alertService.showMessage("Success", mesaj, MessageSeverity.success);
  }

  private saveFailedHelper(error: any) {
    this.alertService.stopLoadingMessage();
    this.alertService.showStickyMessage("Save Error", "Errors: ", MessageSeverity.error, error);
    this.alertService.showStickyMessage(error, null, MessageSeverity.error);
  }

}
